import { DELETE_WATER_METER_INIT, DELETE_WATER_METER_SUCCESS, DELETE_WATER_METER_REQUEST, DELETE_WATER_METER_ERROR } from '../actions/WaterMeterActions'

const initialState = {
	deleteWaterMeter: {}
}

const WaterMeterReducer = function (state = initialState, action) {
	switch (action.type) {
		case DELETE_WATER_METER_INIT: {
			return {
				...state,
				deleteWaterMeter: initialState.deleteWaterMeter
			}
		}
		case DELETE_WATER_METER_REQUEST: {
			return {
				...state,
				deleteWaterMeter: { loading: true }
			}
		}
		case DELETE_WATER_METER_SUCCESS: {
			return {
				...state,
				deleteWaterMeter: {
					loading: false,
					data: action.payload.data,
					success: true
				}
			}
		}
		case DELETE_WATER_METER_ERROR: {
			return {
				...state,
				deleteWaterMeter: {
					loading: false,
					error: action.payload.error
				}
			}
		}
		default: {
			return {
				...state
			}
		}
	}
}

export default WaterMeterReducer
